import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageview } from "../lib/analytics";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    // Only track public site pageviews; admin traffic shouldn't pollute analytics.
    if (!pathname.startsWith("/admin")) {
      trackPageview(pathname);
    }
  }, [pathname]);

  return null;
}
